export function castDateFields(feature, schema) {
  schema.forEach((row) => {
    if (
      row.type === "date" &&
      row.name !== "Modified Date" &&
      row.name !== "Created Date" &&
      feature[row.name].toString().length > 0 &&
      feature[row.name] instanceof Date === false
    ) {
      var dt = feature[row.name] + "T00:00:00";
      feature[row.name] = new Date(dt);
    } else if (
      row.type === "date" &&
      row.name === "Modified Date" &&
      row.name === "Created Date" &&
      feature[row.name] instanceof Date === false
    ) {
      console.log(feature[row.name]);
      var dtt = feature[row.name];
      feature[row.name] = new Date(dtt);
    }
  });
  return feature;
}
